import CloseIcon from "@mui/icons-material/Close";
import ReplyIcon from "@mui/icons-material/Reply";
import SendIcon from "@mui/icons-material/Send";
import { Button, CircularProgress, IconButton, TextField, Typography } from "@mui/material";
import moment from "moment";
import { useRef } from "react";
import { StyledMessaging } from "../../styled/messaging";

const ConversationChatArea = ({
  detail,
  loading,
  messagesEndRef,
  canType,
  isClosedButCanReopen,
  isClosedButCannotReopen,
  inputText,
  setInputText,
  replyTo,
  setReplyTo,
  sending,
  handleSend
}) => {

  const inputRef = useRef(null);

  return (
    <StyledMessaging.ChatAreaContainer>
      <StyledMessaging.ChatAreaHeader>
        <Typography variant="subtitle1" fontWeight="bold">Mensajes</Typography>
      </StyledMessaging.ChatAreaHeader>

      <StyledMessaging.ChatAreaContent>
        {loading && <CircularProgress size={24} sx={{ mx: "auto", mt: 4 }} />}

        {detail && detail.mensajes.map((msg) => {
          const isPrestador = msg.usuarioCreacion.toLowerCase() === "prestador";

          return (
            <StyledMessaging.ChatMessageRow id={`msg-${msg.idMensaje}`} key={msg.idMensaje} isPrestador={isPrestador}>

              {!isPrestador && (
                <StyledMessaging.AvatarPlaceholder isPrestador={isPrestador}>
                  <Typography variant="caption" fontWeight="bold">{msg.usuarioCreacion.substring(0, 2).toUpperCase()}</Typography>
                </StyledMessaging.AvatarPlaceholder>
              )}

              <StyledMessaging.MessageBubbleContainer isPrestador={isPrestador}>
                <StyledMessaging.MessageInfo>
                  <Typography variant="caption" fontWeight="bold" color="textPrimary">
                    {isPrestador ? "Prestador" : `${msg.usuarioCreacion} (ART)`}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    {moment(msg.fechaHoraCreacion).format("DD/MM/YYYY HH:mm")}
                    {msg.estadoMensaje && <StyledMessaging.MessageStatus>{msg.estadoMensaje}</StyledMessaging.MessageStatus>}
                  </Typography>
                </StyledMessaging.MessageInfo>

                <StyledMessaging.MessageBubble elevation={0} isPrestador={isPrestador}>
                  {msg.mensajeOrigen && (
                    <StyledMessaging.OriginalMessagePreview
                      onClick={() => {
                        const el = document.getElementById(`msg-${msg.mensajeOrigen.idMensaje}`);
                        if (el) {
                          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                          el.style.transition = 'background-color 0.5s';
                          const oldBg = el.style.backgroundColor;
                          el.style.backgroundColor = '#fff9c4';
                          setTimeout(() => el.style.backgroundColor = oldBg, 1500);
                        }
                      }}
                    >
                      <StyledMessaging.OriginalMessageText variant="caption" color="primary" fontWeight="bold">
                        <ReplyIcon sx={{ fontSize: 14 }} />
                        {msg.mensajeOrigen.mensaje?.length > 80 ? msg.mensajeOrigen.mensaje.substring(0, 80) + '...' : (msg.mensajeOrigen.mensaje || "Mensaje original")}
                      </StyledMessaging.OriginalMessageText>
                    </StyledMessaging.OriginalMessagePreview>
                  )}

                  <Typography variant="body2" sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                    {msg.mensaje}
                  </Typography>
                </StyledMessaging.MessageBubble>

                {canType && (
                  <Button
                    size="small"
                    startIcon={<ReplyIcon />}
                    sx={{ textTransform: "none", mt: 0.5, fontWeight: "bold" }}
                    onClick={() => {
                      setReplyTo(msg)
                      setTimeout(() => { inputRef.current?.focus() }, 0);
                    }}
                  >
                    Responder
                  </Button>
                )}
              </StyledMessaging.MessageBubbleContainer>

              {isPrestador && (
                <StyledMessaging.AvatarPlaceholder isPrestador={isPrestador}>
                  <Typography variant="caption" fontWeight="bold" color="primary">PR</Typography>
                </StyledMessaging.AvatarPlaceholder>
              )}

            </StyledMessaging.ChatMessageRow>
          );
        })}
        <div ref={messagesEndRef} />
      </StyledMessaging.ChatAreaContent>

      <StyledMessaging.InputAreaContainer>
        {isClosedButCannotReopen ? (
          <Typography variant="body2" color="error" align="center">
            La conversación se encuentra cerrada y no tienes permisos para reabrirla.
          </Typography>
        ) : !canType ? (
          <Typography variant="body2" color="textSecondary" align="center">
            No tienes permisos para responder en esta conversación.
          </Typography>
        ) : (
          <StyledMessaging.InputAreaWrapper>
            {replyTo && (
              <StyledMessaging.ReplyToPreview>
                <Typography variant="caption" color="primary" fontWeight="bold">
                  Respondiendo a: {replyTo.mensaje?.length > 50 ? replyTo.mensaje.substring(0, 50) + '...' : replyTo.mensaje}
                </Typography>
                <IconButton size="small" onClick={() => setReplyTo(null)}>
                  <CloseIcon fontSize="small" color="primary" />
                </IconButton>
              </StyledMessaging.ReplyToPreview>
            )}

            <StyledMessaging.InputActionsWrapper>
              <TextField
                inputRef={inputRef}
                fullWidth
                multiline
                maxRows={4}
                placeholder={isClosedButCanReopen ? "Escribe un mensaje para reabrir..." : "Escribir un mensaje..."}
                variant="standard"
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
                disabled={sending}
                InputProps={{
                  disableUnderline: true,
                  sx: { px: 1, py: 0.5, fontSize: "0.875rem" }
                }}
                inputProps={{ maxLength: 5000 }}
                helperText={`${inputText.length}/5000`}
              />
              <Button
                variant="contained"
                color="primary"
                endIcon={sending ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
                onClick={handleSend}
                disabled={!inputText.trim() || sending}
                sx={{ minWidth: 100, borderRadius: 1, textTransform: "none", ml: 1 }}
              >
                Enviar
              </Button>
            </StyledMessaging.InputActionsWrapper>
          </StyledMessaging.InputAreaWrapper>
        )}
      </StyledMessaging.InputAreaContainer>
    </StyledMessaging.ChatAreaContainer>
  );
};

export default ConversationChatArea;
